import styled from "styled-components";
import Form from "react-bootstrap/esm/Form";

const FormText = styled(Form.Text)`
  margin: 0px 0px 0.5rem 0px;
`;

export default FormText;
